import { redirect } from '@tanstack/react-router';
import type { QueryClient } from '@tanstack/react-query';
import type { AuthUser, UserRole } from '@runik/shared';
import { auth } from './client';
import { meQueryKey } from './hooks';

export async function ensureUser(qc: QueryClient): Promise<AuthUser | null> {
  return qc.ensureQueryData({
    queryKey: meQueryKey,
    queryFn: () => auth.me(),
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
}

export async function requireAuth(qc: QueryClient, fromPath: string): Promise<AuthUser> {
  const user = await ensureUser(qc);
  if (!user) {
    throw redirect({ to: '/login', search: { from: fromPath } });
  }
  return user;
}

export async function requireRole(
  qc: QueryClient,
  fromPath: string,
  ...roles: UserRole[]
): Promise<AuthUser> {
  const user = await requireAuth(qc, fromPath);
  if (!roles.includes(user.role)) {
    throw redirect({ to: '/forbidden' });
  }
  return user;
}

export async function requireAnonymous(qc: QueryClient): Promise<void> {
  const user = await ensureUser(qc);
  if (user) {
    throw redirect({ to: '/dashboard' });
  }
}
